'use strict'

import st from './scrollto'
import GoogleMaps from './google-maps'
import wpapi from './wpapi'

let self

export default self = {
  container : document.getElementById('listing-detail'),
  detailNav : document.querySelector('#listing-detail .detail-nav'),

  map : {
    container : document.getElementById('map'),
    api : null,
    obj : null,
    marker : null,
    zoom: 15
  },

  init : () => {
    wpapi.init()
    self.registerEvents()
    self.setupMap()
    self.buildingLookup()
  },

  registerEvents : () => {
    self.detailNav.addEventListener("click", self.navScroll)
    if (document.querySelector('.video-wrapper')) {
	    document.querySelector('.video-wrapper button').addEventListener('click', function () {
		    document.querySelector('.video-wrapper').classList.add('playing');
		    document.querySelector('.video-wrapper iframe').setAttribute('src', document.querySelector('.video-wrapper iframe').getAttribute('src') + '&autoplay=1');
		    console.log(document.querySelector('.video-wrapper iframe').getAttribute('src'));
	    })
    }
  },




  /*

    Events


  */
  navScroll : e => {
    if (e.target.nodeName !== 'A') return false;
    e.preventDefault()
    let id = e.target.getAttribute("href")
    let scrollEL = document.querySelector(id)

    st.animate(scrollEL.offsetTop, 1000)
  },







  /*

    Map


  */
  setupMap : () => {
	if (document.getElementById('map')) {
	    const address = self.map.container.getAttribute("data-address") || ""
	    const city = self.map.container.getAttribute("data-city") || ""
	    let coords = self.map.container.getAttribute("data-latlng")
	        coords = (coords) ? coords.split(",") : null
	
	    GoogleMaps.api()
	      .then(res => {
	        self.map.api = res
			
	        if ( coords ) {
	          return self.setMapMarker({
	            geo : {
	              lat : coords[0],
	              lng : coords[1]
	            }
	          })
	        } else {
	          GoogleMaps.getLatLngFromAddress(self.map.api, address,city)
	            .then( geo => self.setMapMarker({ geo : geo }) )
	        }
	      })
	      .catch( err => console.error(err) )
      }
  },


  setMapMarker : ({ geo }) => {
    const latlng = new self.map.api.LatLng(geo.lat, geo.lng)

    // Change the default zoom
    GoogleMaps.mapArgs.zoom = self.map.zoom
    GoogleMaps.mapArgs.center = latlng

    // Create the map
    self.map.obj = new self.map.api.Map(self.map.container, GoogleMaps.mapArgs)

    // Create the marker
    self.map.marker = new self.map.api.Marker({
      position: latlng,
      map: self.map.obj,
      icon : GoogleMaps.markerIcon
    })
  },



  buildingLookup : () => {
	const address = document.getElementById('map') ? self.map.container.getAttribute("data-address") : '';
    const buildingNameContainer = self.container.querySelector('.side-info .building-name')
    const buildingNameInTitle = self.container.querySelector('.detail-nav .building-name')

    wpapi.wp.buildings()
      .param('meta_key', 'address')
      .param('meta_value', address)
      .then( res => {
        const building = res[0]
        if ( !building ) return false

        buildingNameContainer.classList.remove('hidden')
        buildingNameContainer.href = building.link
        buildingNameContainer.querySelector('.info-value').innerText = building.title.rendered

        buildingNameInTitle.classList.remove('hidden')
        buildingNameInTitle.innerHTML = `${building.title.rendered} &mdash;&nbsp;`
      })
  }







}
